import { ApolloLink, Observable } from '@apollo/client';
import Session from 'supertokens-auth-react/recipe/session';
import Debug from 'debug';
import { formatDistanceToNow, fromUnixTime } from 'date-fns';
const debug = Debug('APOLLO.PreRequestRefreshLink');
// debug.enabled = true;

const REFRESH_IF_EXPIRES_WITHIN_MS = 30_000;

/**
 * Link de apollo que intenta refrescar la sesión preventivamente, si detecta que se venció
 */
export function buildPreRequestRefreshLink() {
    debug('Valor para preventivamente refrescar es ', 3_000);
    return new ApolloLink((operation, forward) => {
        return new Observable((observer) => {
            const expiresAtMs = getFrontTokenExpiry();
            if (expiresAtMs) {
                debug(
                    `La token expira en ${formatDistanceToNow(
                        fromUnixTime(expiresAtMs / 1000),
                        {
                            includeSeconds: true,
                            addSuffix: true,
                        }
                    )}`
                );
            } else {
                debug('No pudimos obtener la token');
            }

            const continueRequest = () => {
                forward(operation).subscribe(observer);
            };

            if (!expiresAtMs || !shouldRefreshSoon(expiresAtMs)) {
                debug(`La token no expira pronto, así que no hacemos nada`);
                continueRequest();
                return;
            }

            debug(`La token expira pronto, así intentamos hacer un refresh`);
            void Session.attemptRefreshingSession()
                .catch((reason) => {
                    debug(
                        `DIO ERROR: ${JSON.stringify(reason, null, 2)}, pero dejamos que lo maneje el siguiente`
                    );
                    // Ignore here and let the normal request / error flow handle it
                })
                .finally(() => {
                    continueRequest();
                });
        });
    });
}

function getFrontTokenExpiry(): number | undefined {
    const raw = getCookie('sFrontToken');
    if (!raw) return undefined;

    /**
     * {
        "uid": __supertokens_user_id,
        "ate": 1773093631000,
        "up": {
            "iat": 1773093616,
            "exp": 1773093631,
            "sub": __supertokens_user_id,
            "tId": "public",
            "rsub": __supertokens_user_id,
            "sessionHandle": "...",
            "refreshTokenHash1": "...",
            "parentRefreshTokenHash1": "...",
            "antiCsrfToken": null,
            "iss": "https://auth.dluker.io",
            "legacy_id": "ID",
            "is_sadmin": true/false
        }
    }
     */
    try {
        const decoded = JSON.parse(atob(raw)) as { ate?: number };
        return typeof decoded?.ate === 'number' ? decoded.ate : undefined;
    } catch {
        return undefined;
    }
}

function shouldRefreshSoon(expiresAtMs: number): boolean {
    return expiresAtMs - Date.now() <= REFRESH_IF_EXPIRES_WITHIN_MS;
}

function getCookie(name: string): string | undefined {
    const prefix = `${name}=`;
    return document.cookie
        .split('; ')
        .find((row) => row.startsWith(prefix))
        ?.slice(prefix.length);
}
